import { PhysicalAddress } from './PhysicalAddress';

/* eslint-disable @typescript-eslint/naming-convention */
export interface PendingAddress {
  PhysicalAddress: PhysicalAddress;
  HRRef: number;
}
